import { EnvironmentName } from './environment.constant';

export interface Endpoints {
  apiUrl: string;
  apiPrefix: string;
  openInfoApiUrl: string;
  fcmApiUrl: string;
  wsApiUrl: string;
  skidUrl: string;
  skidChinaUrl: string;
}

export interface Environment {
  env: string;
  envName: EnvironmentName;
  rootEnv: string;
  api: Endpoints;
  googleMapsApiKey: string;
  inspectionBaseUrl: string;
  faroCollectorUrl: string;
  faroApiKey: string;
  agGridLicenseKey: string;
}
